/**
 * @class ExampleComponent
 */
import "babel-polyfill";

import * as React from 'react';
import * as ReactDOM from 'react-dom';
export { React, ReactDOM }

import * as antd from 'antd';
export { antd }

import 'antd/dist/antd.css';

// import * as Antd from 'antd/dist/antd.js';
// var Antd = require("antd/dist/antd.js")
// export { Antd }

// import styles from './styles.css'
// import DynamicColTable from "./DynamicColTable/DynamicColTablets";
// export { DynamicColTable }

import { AntWfDragForm, DynamicColTable } from "qyb-react-easyui";
export { AntWfDragForm, DynamicColTable }

export default class TestComponent extends React.Component<any> {
  render() {
    const {
      text
    } = this.props

    return (
      // <div className={styles.test}>
      <div>
        Example Component: {text}
      </div>
    )
  }
}


